<template lang='pug' src='./privacy-policy.pug'></template>

<script>

export default {
  name: 'privacy-policy',
  computed: {
    props () {
      return this.$store.state.pages.privacy
    },
    loading () {
      return this.$store.state.loading
    }
  },
  components: {
  }
}
</script>



// WEBPACK FOOTER //
// privacy-policy.vue?5f0f5ad6